// import React, { useEffect, useMemo, useState } from "react";
// import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner, Modal, ListGroup } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./FormsAssignedByMePage.css";

// // Phase 4C, §17. Dedicated view for an authorized assigner: assignments
// // THEY created (form_assignments.created_by = req.user.id), never every
// // assignment in the system, unless they separately hold form_assignments:
// // view_all/manage_all (in which case an "All Assignments" toggle appears —
// // Admin's default view remains the full FormAssignmentManagementPage list).
// const STATUS_VARIANTS = { DRAFT: "secondary", ACTIVE: "success", CLOSED: "dark", CANCELLED: "danger", ARCHIVED: "secondary" };

// export default function FormsAssignedByMePage() {
//   const { can, canAny, loading: permissionsLoading } = usePermissions();
//   const canViewAll = can("form_assignments", "view_all") || can("form_assignments", "manage_all");
//   const hasAnyAssignmentAccess = canAny([
//     { moduleKey: "form_assignments", actionKey: "create" },
//     { moduleKey: "form_assignments", actionKey: "view_own" },
//     { moduleKey: "form_assignments", actionKey: "view" },
//     { moduleKey: "form_assignments", actionKey: "view_all" },
//     { moduleKey: "form_assignments", actionKey: "manage_all" },
//   ]);

//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [scope, setScope] = useState("own");
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 20;

//   const [usersModalTarget, setUsersModalTarget] = useState(null);
//   const [assignedUsers, setAssignedUsers] = useState([]);
//   const [usersLoading, setUsersLoading] = useState(false);
//   const [busyId, setBusyId] = useState(null);

//   const fetchRows = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get("/form-assignments/assigned-by-me", {
//         params: {
//           search: search || undefined,
//           status: statusFilter || undefined,
//           scope: scope === "all" ? "all" : undefined,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setRows(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to fetch assignments");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRows();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, statusFilter, scope, currentPage]);

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const setStatus = async (row, status) => {
//     setBusyId(row.id);
//     try {
//       await api.patch(`/form-assignments/${row.id}/status`, { status });
//       toast.success(`Assignment ${status.toLowerCase()}`);
//       fetchRows();
//     } catch (err) {
//       toast.error(err.response?.data?.message || `Failed to set status to ${status}`);
//     } finally {
//       setBusyId(null);
//     }
//   };

//   const openUsersModal = async (row) => {
//     setUsersModalTarget(row);
//     setUsersLoading(true);
//     try {
//       const res = await api.get(`/form-assignments/${row.id}/users`);
//       setAssignedUsers(Array.isArray(res.data?.data) ? res.data.data : []);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load assigned users");
//     } finally {
//       setUsersLoading(false);
//     }
//   };

//   const closeUsersModal = () => {
//     setUsersModalTarget(null);
//     setAssignedUsers([]);
//   };

//   const cancelAssignmentUser = async (assignmentUserId) => {
//     if (!usersModalTarget) return;
//     if (!window.confirm("Cancel this user's assignment? Any already-submitted response is preserved.")) return;
//     try {
//       await api.delete(`/form-assignments/${usersModalTarget.id}/users/${assignmentUserId}`);
//       toast.success("User's assignment cancelled");
//       openUsersModal(usersModalTarget);
//       fetchRows();
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to cancel user's assignment");
//     }
//   };

//   const columns = useMemo(() => [
//     "Title", "Project / Module", "Form", "Type", "Assigned", "Pending", "In Progress", "Submitted", "Completed", "Overdue", "Due Date", "Created", "Status", "Actions",
//   ], []);

//   if (permissionsLoading) {
//     return <div className="unit-page formsbyme-theme"><div className="unit-loader"><Spinner animation="border" /></div></div>;
//   }

//   if (!hasAnyAssignmentAccess) {
//     return (
//       <div className="unit-page formsbyme-theme">
//         <div className="unit-empty">
//           <div className="unit-empty-icon"><i className="fa-solid fa-lock" aria-hidden="true"></i></div>
//           <h5>Access denied</h5>
//           <p>You do not have permission to view form assignments.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="unit-page formsbyme-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Forms</div>
//           <h2>Forms Assigned By Me</h2>
//           <p>Assignments you created, and how each assignee is progressing.</p>
//         </div>
//         <div className="unit-header-actions">
//           {canViewAll && (
//             <Form.Select style={{ maxWidth: 180 }} value={scope} onChange={(e) => { setCurrentPage(1); setScope(e.target.value); }}>
//               <option value="own">Assigned By Me</option>
//               <option value="all">All Assignments</option>
//             </Form.Select>
//           )}
//           <Button className="unit-btn unit-btn-light" onClick={fetchRows}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-share-from-square fabm-list-icon" aria-hidden="true"></i>
//               Assignments You've Created
//             </h5>
//             <p>Track recipient progress for every form you've assigned.</p>
//           </div>
//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 220 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search title..."
//                 aria-label="Search by assignment title"
//                 value={search}
//                 onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }}
//               />
//             </InputGroup>
//             <Form.Select style={{ maxWidth: 160 }} value={statusFilter} onChange={(e) => { setCurrentPage(1); setStatusFilter(e.target.value); }}>
//               <option value="">All Statuses</option>
//               {Object.keys(STATUS_VARIANTS).map((s) => <option key={s} value={s}>{s}</option>)}
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading assignments...</p></div>
//           ) : (
//             <Table className="unit-table">
//               <thead><tr>{columns.map((c) => <th key={c}>{c}</th>)}</tr></thead>
//               <tbody>
//                 {rows.length > 0 ? rows.map((row) => (
//                   <tr key={row.id}>
//                     <td><strong>{row.assignment_title}</strong></td>
//                     <td className="small text-muted">{row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</td>
//                     <td className="small">{row.form_name} <span className="text-muted">v{row.version_number}</span></td>
//                     <td><Badge bg="light" text="dark">{row.form_type_name}</Badge></td>
//                     <td>{row.assigned_count}</td>
//                     <td>{row.pending_count}</td>
//                     <td>{row.in_progress_count}</td>
//                     <td>{row.submitted_count}</td>
//                     <td>{row.completed_count}</td>
//                     <td>{row.overdue_count > 0 ? <Badge bg="danger">{row.overdue_count}</Badge> : 0}</td>
//                     <td className="small">{row.due_at ? new Date(row.due_at).toLocaleString() : "—"}</td>
//                     <td className="small">{row.created_at ? new Date(row.created_at).toLocaleDateString() : "—"}</td>
//                     <td><Badge bg={STATUS_VARIANTS[row.status] || "secondary"}>{row.status}</Badge></td>
//                     <td>
//                       <div className="unit-actions" style={{ flexWrap: "wrap" }}>
//                         <Button size="sm" variant="outline-primary" onClick={() => openUsersModal(row)}>
//                           <i className="fa-solid fa-users" aria-hidden="true"></i>
//                           View Users
//                         </Button>
//                         {row.status === "ACTIVE" && can("form_assignments", "close") && (
//                           <Button size="sm" variant="outline-secondary" disabled={busyId === row.id} onClick={() => setStatus(row, "CLOSED")}>
//                             <i className="fa-solid fa-lock" aria-hidden="true"></i>
//                             Close
//                           </Button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 )) : (
//                   <tr>
//                     <td colSpan={columns.length}>
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon"><i className="fa-solid fa-paper-plane" aria-hidden="true"></i></div>
//                         <h5>No assignments found</h5>
//                         <p>Assignments you create from Assign Form will appear here.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> assignments</div>
//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal show={!!usersModalTarget} onHide={closeUsersModal} centered size="lg" className="unit-modal fabm-modal">
//         <Modal.Header closeButton><Modal.Title>Assigned Employees — {usersModalTarget?.assignment_title}</Modal.Title></Modal.Header>
//         <Modal.Body>
//           {usersLoading ? (
//             <div className="unit-loader"><Spinner animation="border" /></div>
//           ) : (
//             <ListGroup>
//               {assignedUsers.length === 0 && <div className="text-muted small">No employees assigned yet.</div>}
//               {assignedUsers.map((u) => (
//                 <ListGroup.Item key={u.id} className="d-flex justify-content-between align-items-center">
//                   <span>
//                     {u.user_name} <span className="text-muted small">({u.username})</span>{" "}
//                     <Badge bg="light" text="dark" className="ms-1">{u.status}</Badge>
//                     {u.submission_count > 0 && <span className="text-muted small ms-2">{u.submission_count} submission(s)</span>}
//                   </span>
//                   {u.status !== "CANCELLED" && (
//                     <Can moduleKey="form_assignments" actionKey="remove_users">
//                       <Button size="sm" variant="outline-danger" onClick={() => cancelAssignmentUser(u.id)}>
//                         <i className="fa-solid fa-user-slash" aria-hidden="true"></i>
//                         Cancel
//                       </Button>
//                     </Can>
//                   )}
//                 </ListGroup.Item>
//               ))}
//             </ListGroup>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeUsersModal}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { useNavigate } from "react-router-dom";
import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner, Modal, ListGroup } from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import ExternalRecipientBadge, { isExternalRecipient } from "../../components/forms/ExternalRecipientBadge";
import "./FormsAssignedByMePage.css";

// Phase 4C, §17. Dedicated view for an authorized assigner: assignments
// THEY created (form_assignments.created_by = req.user.id), never every
// assignment in the system, unless they separately hold form_assignments:
// view_all/manage_all (in which case an "All Assignments" toggle appears —
// Admin's default view remains the full FormAssignmentManagementPage list).
const STATUS_VARIANTS = { DRAFT: "secondary", ACTIVE: "success", CLOSED: "dark", CANCELLED: "danger", ARCHIVED: "secondary" };

// Dynamic Forms visibility audit, §6: same rolePrefix derivation
// FormSubmissionViewPage already uses -- this page is mounted at
// /admin/forms-assigned-by-me AND /<role>/forms-assigned-by-me alike.
function useRolePrefix() {
  const path = window.location.pathname;
  const match = path.match(/^\/([^/]+)\//);
  return match ? match[1] : "admin";
}

export default function FormsAssignedByMePage() {
  const { can, canAny, loading: permissionsLoading } = usePermissions();
  const navigate = useNavigate();
  const rolePrefix = useRolePrefix();
  const canViewAll = can("form_assignments", "view_all") || can("form_assignments", "manage_all");
  const hasAnyAssignmentAccess = canAny([
    { moduleKey: "form_assignments", actionKey: "create" },
    { moduleKey: "form_assignments", actionKey: "view_own" },
    { moduleKey: "form_assignments", actionKey: "view" },
    { moduleKey: "form_assignments", actionKey: "view_all" },
    { moduleKey: "form_assignments", actionKey: "manage_all" },
  ]);

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [scope, setScope] = useState("own");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const [usersModalTarget, setUsersModalTarget] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [busyId, setBusyId] = useState(null);
  const [viewResponseBusyId, setViewResponseBusyId] = useState(null);
  const [submissionsPicker, setSubmissionsPicker] = useState(null); // { user, submissions }

  const fetchRows = async () => {
    setLoading(true);
    try {
      const res = await api.get("/form-assignments/assigned-by-me", {
        params: {
          search: search || undefined,
          status: statusFilter || undefined,
          scope: scope === "all" ? "all" : undefined,
          page: currentPage,
          pageSize,
        },
      });
      setRows(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch assignments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter, scope, currentPage]);

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const setStatus = async (row, status) => {
    setBusyId(row.id);
    try {
      await api.patch(`/form-assignments/${row.id}/status`, { status });
      toast.success(`Assignment ${status.toLowerCase()}`);
      fetchRows();
    } catch (err) {
      toast.error(err.response?.data?.message || `Failed to set status to ${status}`);
    } finally {
      setBusyId(null);
    }
  };

  const openUsersModal = async (row) => {
    setUsersModalTarget(row);
    setUsersLoading(true);
    try {
      const res = await api.get(`/form-assignments/${row.id}/users`);
      setAssignedUsers(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load assigned users");
    } finally {
      setUsersLoading(false);
    }
  };

  const closeUsersModal = () => {
    setUsersModalTarget(null);
    setAssignedUsers([]);
  };

  const cancelAssignmentUser = async (assignmentUserId) => {
    if (!usersModalTarget) return;
    if (!window.confirm("Cancel this user's assignment? Any already-submitted response is preserved.")) return;
    try {
      await api.delete(`/form-assignments/${usersModalTarget.id}/users/${assignmentUserId}`);
      toast.success("User's assignment cancelled");
      openUsersModal(usersModalTarget);
      fetchRows();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to cancel user's assignment");
    }
  };

  // Dynamic Forms visibility audit, §6: an assigner-facing "View Response"
  // action -- previously the modal only showed a raw submission_count with
  // no way to actually open a response. Fetches the assignee's submission
  // ids from the new GET .../submissions endpoint (metadata only); opening
  // one still goes through GET /form-submissions/:id/runtime, which
  // independently enforces canAssignerAccessSubmission server-side, so this
  // is safe to expose whenever submission_count > 0 without a client-side
  // permission pre-check.
  const viewResponse = async (u) => {
    if (!usersModalTarget) return;
    setViewResponseBusyId(u.id);
    try {
      const res = await api.get(`/form-assignments/${usersModalTarget.id}/users/${u.id}/submissions`);
      const submissions = Array.isArray(res.data?.data) ? res.data.data : [];
      if (submissions.length === 0) {
        toast.info("No submission found for this user yet.");
      } else if (submissions.length === 1) {
        navigate(`/${rolePrefix}/form-submissions/${submissions[0].id}`);
      } else {
        setSubmissionsPicker({ user: u, submissions });
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load this user's submissions");
    } finally {
      setViewResponseBusyId(null);
    }
  };

  const closeSubmissionsPicker = () => setSubmissionsPicker(null);

  const columns = useMemo(() => [
    "Title", "Project / Module", "Form", "Type", "Assigned", "Pending", "In Progress", "Submitted", "Completed", "Overdue", "Due Date", "Created", "Status", "Actions",
  ], []);

  if (permissionsLoading) {
    return <div className="unit-page formsbyme-theme"><div className="unit-loader"><Spinner animation="border" /></div></div>;
  }

  if (!hasAnyAssignmentAccess) {
    return (
      <div className="unit-page formsbyme-theme">
        <div className="unit-empty">
          <div className="unit-empty-icon"><i className="fa-solid fa-lock" aria-hidden="true"></i></div>
          <h5>Access denied</h5>
          <p>You do not have permission to view form assignments.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="unit-page formsbyme-theme">

      <div className="formsbyme-heading-box">
        <div className="formsbyme-heading-content">
          <div className="formsbyme-heading-icon">
            <i className="fa-solid fa-share-from-square" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Forms</div>
            <h2>Forms Assigned By Me</h2>
            <p>Assignments you created, and how each assignee is progressing.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          {canViewAll && (
            <div className="formsbyme-scope-wrap">
              <i className="fa-solid fa-user-shield formsbyme-scope-icon" aria-hidden="true"></i>
              <Form.Select
                className="formsbyme-scope-select"
                value={scope}
                onChange={(e) => {
                  setCurrentPage(1);
                  setScope(e.target.value);
                }}
              >
                <option value="own">Assigned By Me</option>
                <option value="all">All Assignments</option>
              </Form.Select>
            </div>
          )}
          <Button className="unit-btn unit-btn-light" onClick={fetchRows}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card formsbyme-stat-blue">
          <div className="formsbyme-stat-content">
            <div className="formsbyme-stat-text">
              <span>Total Assignments</span>
              <strong>{total}</strong>
            </div>

            <div className="formsbyme-stat-icon">
              <i className="fa-solid fa-paper-plane" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card formsbyme-stat-purple">
          <div className="formsbyme-stat-content">
            <div className="formsbyme-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="formsbyme-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card formsbyme-stat-green">
          <div className="formsbyme-stat-content">
            <div className="formsbyme-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="formsbyme-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar formsbyme-toolbar">
          <div className="formsbyme-section-title">
            <div className="formsbyme-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="formsbyme-section-copy">
              <h5>Assignments You've Created</h5>
              <p>Track recipient progress for every form you've assigned.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions formsbyme-filters-row">
            <InputGroup className="unit-search formsbyme-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search title..."
                aria-label="Search by assignment title"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>
            <div className="formsbyme-select-wrap">
              <i className="fa-solid fa-circle-check formsbyme-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="formsbyme-filter-select"
                value={statusFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setStatusFilter(e.target.value);
                }}
              >
                <option value="">All Statuses</option>
                {Object.keys(STATUS_VARIANTS).map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader"><Spinner animation="border" /><p>Loading assignments...</p></div>
          ) : (
            <Table className="unit-table">
              <thead>
                <tr>
                  {columns.map((c) => (
                    <th
                      key={c}
                      className={c === "Actions" ? "formsbyme-actions-header text-end" : undefined}
                    >
                      {c}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <div className="formsbyme-name-box">
                        <div className="formsbyme-letter">
                          {row.assignment_title?.charAt(0)?.toUpperCase() || "A"}
                        </div>

                        <div className="formsbyme-name-copy">
                          <strong title={row.assignment_title}>{row.assignment_title}</strong>
                          <small>Assignment #{row.id}</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="formsbyme-scope-cell">
                        {row.project_name ? (
                          <span className="formsbyme-project-chip">
                            <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
                            {row.project_name}
                          </span>
                        ) : (
                          <span className="formsbyme-muted">No project</span>
                        )}

                        {row.project_module_name && (
                          <span className="formsbyme-module-chip">
                            <i className="fa-solid fa-cubes" aria-hidden="true"></i>
                            {row.project_module_name}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="formsbyme-form-chip">
                        <i className="fa-regular fa-file-lines" aria-hidden="true"></i>
                        <span>{row.form_name}</span>
                        <small>v{row.version_number}</small>
                      </div>
                    </td>
                    <td>
                      <span className="formsbyme-type-chip">
                        <i className="fa-solid fa-shapes" aria-hidden="true"></i>
                        {row.form_type_name}
                      </span>
                    </td>
                    <td><span className="formsbyme-count-chip formsbyme-count-assigned"><i className="fa-solid fa-users" aria-hidden="true"></i>{row.assigned_count}</span></td>
                    <td><span className="formsbyme-count-chip formsbyme-count-pending"><i className="fa-regular fa-clock" aria-hidden="true"></i>{row.pending_count}</span></td>
                    <td><span className="formsbyme-count-chip formsbyme-count-progress"><i className="fa-solid fa-spinner" aria-hidden="true"></i>{row.in_progress_count}</span></td>
                    <td><span className="formsbyme-count-chip formsbyme-count-submitted"><i className="fa-solid fa-paper-plane" aria-hidden="true"></i>{row.submitted_count}</span></td>
                    <td><span className="formsbyme-count-chip formsbyme-count-completed"><i className="fa-solid fa-circle-check" aria-hidden="true"></i>{row.completed_count}</span></td>
                    <td>
                      {row.overdue_count > 0 ? (
                        <span className="formsbyme-overdue-chip">
                          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                          {row.overdue_count}
                        </span>
                      ) : (
                        <span className="formsbyme-count-chip formsbyme-count-zero">0</span>
                      )}
                    </td>
                    <td>
                      {row.due_at ? (
                        <span className="formsbyme-date-chip formsbyme-due-chip">
                          <i className="fa-regular fa-calendar" aria-hidden="true"></i>
                          {new Date(row.due_at).toLocaleString()}
                        </span>
                      ) : (
                        <span className="formsbyme-muted">—</span>
                      )}
                    </td>
                    <td>
                      {row.created_at ? (
                        <span className="formsbyme-date-chip">
                          <i className="fa-regular fa-calendar-plus" aria-hidden="true"></i>
                          {new Date(row.created_at).toLocaleDateString()}
                        </span>
                      ) : (
                        <span className="formsbyme-muted">—</span>
                      )}
                    </td>
                    <td>
                      <Badge
                        bg={STATUS_VARIANTS[row.status] || "secondary"}
                        className={`formsbyme-status-badge formsbyme-status-${String(
                          row.status || ""
                        ).toLowerCase()}`}
                      >
                        {row.status}
                      </Badge>
                    </td>
                    <td className="formsbyme-actions-cell">
                      <div className="unit-actions formsbyme-actions">
                        <Button
                          className="formsbyme-action-btn formsbyme-action-users"
                          onClick={() => openUsersModal(row)}
                          title="View Users"
                          aria-label={`View users for ${row.assignment_title}`}
                        >
                          <i className="fa-solid fa-users" aria-hidden="true"></i>
                        </Button>

                        {row.status === "ACTIVE" &&
                          can("form_assignments", "close") && (
                            <Button
                              className="formsbyme-action-btn formsbyme-action-close"
                              disabled={busyId === row.id}
                              onClick={() => setStatus(row, "CLOSED")}
                              title="Close Assignment"
                              aria-label={`Close ${row.assignment_title}`}
                            >
                              {busyId === row.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <i className="fa-solid fa-lock" aria-hidden="true"></i>
                              )}
                            </Button>
                          )}
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={columns.length}>
                      <div className="unit-empty">
                        <div className="unit-empty-icon"><i className="fa-solid fa-paper-plane" aria-hidden="true"></i></div>
                        <h5>No assignments found</h5>
                        <p>Assignments you create from Assign Form will appear here.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> assignments</div>
          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={!!usersModalTarget}
        onHide={closeUsersModal}
        centered
        size="lg"
        className="unit-modal fabm-modal"
        dialogClassName="formsbyme-admin-modal formsbyme-admin-modal-lg"
        backdropClassName="formsbyme-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="formsbyme-modal-heading">
            <div className="formsbyme-modal-icon">
              <i className="fa-solid fa-users" aria-hidden="true"></i>
            </div>

            <div>
              <small>Assignment Recipients</small>
              <Modal.Title>
                Assigned Employees — {usersModalTarget?.assignment_title}
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {usersLoading ? (
            <div className="unit-loader"><Spinner animation="border" /></div>
          ) : (
            <ListGroup>
              {assignedUsers.length === 0 && <div className="text-muted small">No employees assigned yet.</div>}
              {assignedUsers.map((u) => (
                <ListGroup.Item key={u.id} className="formsbyme-user-item">
                  <div className="formsbyme-user-info">
                    <div className="formsbyme-user-avatar">
                      {u.user_name?.charAt(0)?.toUpperCase() || "U"}
                    </div>

                    <div>
                      <strong>{u.user_name}</strong>
                      <ExternalRecipientBadge external={isExternalRecipient(u)} />
                      {/* External recipient: no username -- show the address instead. */}
                      <small>{isExternalRecipient(u) ? (u.recipient_email || u.user_email) : u.username}</small>

                      <div className="formsbyme-user-meta">
                        <Badge className="formsbyme-user-status">{u.status}</Badge>
                        {u.submission_count > 0 && (
                          <span>
                            <i className="fa-solid fa-file-circle-check" aria-hidden="true"></i>
                            {u.submission_count} submission(s)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    {u.submission_count > 0 && (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="forms-view-response-btn"
                        disabled={viewResponseBusyId === u.id}
                        onClick={() => viewResponse(u)}
                        title={u.submission_count > 1 ? `View Submissions (${u.submission_count})` : "View Response"}
                      >
                        {viewResponseBusyId === u.id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <i className="fa-solid fa-eye" aria-hidden="true"></i>
                        )}{" "}
                        {u.submission_count > 1 ? `View Submissions (${u.submission_count})` : "View Response"}
                      </Button>
                    )}
                    {u.status !== "CANCELLED" && (
                      <Can moduleKey="form_assignments" actionKey="remove_users">
                        <Button
                          className="formsbyme-user-cancel"
                          onClick={() => cancelAssignmentUser(u.id)}
                          title="Cancel this user's assignment"
                          aria-label={`Cancel assignment for ${u.user_name}`}
                        >
                          <i className="fa-solid fa-user-slash" aria-hidden="true"></i>
                        </Button>
                      </Can>
                    )}
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeUsersModal}>
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Dynamic Forms visibility audit, §6: "View Submissions (N)" picker --
          only shown when an assignee has more than one submission
          (allow_multiple_submissions); a single submission navigates
          straight to FormSubmissionViewPage instead. */}
      <Modal show={!!submissionsPicker} onHide={closeSubmissionsPicker} centered className="unit-modal">
        <Modal.Header closeButton>
          <Modal.Title>Submissions — {submissionsPicker?.user?.user_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup>
            {(submissionsPicker?.submissions || []).map((s) => (
              <ListGroup.Item key={s.id} className="d-flex justify-content-between align-items-center">
                <span>
                  Submission #{s.submission_number}{" "}
                  <Badge bg="light" text="dark" className="ms-1">{s.status}</Badge>
                  {s.submitted_at && (
                    <span className="text-muted small ms-2">{new Date(s.submitted_at).toLocaleString()}</span>
                  )}
                </span>
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => navigate(`/${rolePrefix}/form-submissions/${s.id}`)}
                >
                  <i className="fa-solid fa-eye" aria-hidden="true"></i>
                  Open
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeSubmissionsPicker}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
